import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage, MessageDescriptor } from "react-intl";

const createMessage = <T extends Record<string, Record<string, MessageDescriptor>>>(messages: T) =>
  messages;

const messages = createMessage({
  tooltip: {
    showCC: {
      id: "reservationDetail.tooltipShowCC",
      defaultMessage: "show CC",
    },
  },
});

const tooltipConfig = {
  delay: { show: 250, hide: 0 },
};

const overlay = (
  <Tooltip id="showCC-tooltip" {...tooltipConfig}>
    <FormattedMessage {...messages.tooltip.showCC} />
  </Tooltip>
);

export function CreditCardDataTooltip({ children }) {
  return (
    <OverlayTrigger {...tooltipConfig} overlay={overlay}>
      {children}
    </OverlayTrigger>
  );
}
